import React from 'react';
import NumberFormat from 'react-number-format';
import styles from './styles.module.scss';

import LinkLang from '../../Wraps/LinkLang';
import { ReactComponent as Fav } from '../../../assets/icons/icon-favorite.svg';
import { ReactComponent as Star } from '../../../assets/icons/icon-star-filled.svg';
import { ReactComponent as StarEmpty } from '../../../assets/icons/icon-star-outline.svg';

import Config from '../../../config/config';

const Rating = ({ value }) => (
  <div className={styles.rating}>
    {value >= 1 ? <Star /> : <StarEmpty />}
    {value >= 2 ? <Star /> : <StarEmpty />}
    {value >= 3 ? <Star /> : <StarEmpty />}
    {value >= 4 ? <Star /> : <StarEmpty />}
    {value >= 5 ? <Star /> : <StarEmpty />}
  </div>
);

const Favorite = ({ spanish }) => (
  <div className={styles.fav}>
    <div className={styles.favContent}>
      <div className={styles.favIcon}>
        <Fav />
      </div>
      <div className={styles.favMessage}>
        <p>
          {spanish
            ? 'Por favor inicia sesión para agregar productos a tus favoritos'
            : 'Please sign in to add products to your wishlist'}
        </p>
      </div>
    </div>
  </div>
);

const Item = ({ productInfo, productInfoApi, spanish, addToCart }) => {
  const addToBag = spanish ? 'AGREGAR A LA BOLSA' : 'ADD TO BAG';
  return (
    <div className={styles.container}>
      <div className={styles.image}>
        <LinkLang
          to={`/product/${productInfo.SLUG}`}
          state={{ sku: productInfo?.SKU }}
        >
          <img
            src={Config.cdn.cdn_path + productInfo?.imageCatalog?.url}
            alt={productInfo?.Name}
          />
        </LinkLang>
        <Favorite spanish={spanish} />
      </div>
      <Rating value={productInfoApi?.Calificacion} />
      <LinkLang
        to={`/product/${productInfo.SLUG}`}
        className={styles.name}
        state={{ sku: productInfo?.SKU }}
      >
        {productInfo?.Name}
      </LinkLang>
      {productInfoApi && (
        <p className={styles.specs}>{`${
          productInfoApi?.unidades_envase ? productInfoApi?.unidades_envase : ''
        } ${productInfoApi?.presentacion}`}</p>
      )}
      <p className={styles.price}>
        <NumberFormat
          value={productInfoApi?.precioRetail}
          thousandSeparator
          prefix="$"
          suffix=" MXN"
          displayType="text"
        />
      </p>
      {productInfoApi?.existencia === false ? (
        <div className={styles.soldOut}>
          {spanish ? 'Sin existencias' : 'Sold out'}
        </div>
      ) : (
        <button
          type="button"
          className="btn btn-white"
          onClick={() => addToCart(productInfoApi.cve_prod)}
        >
          {addToBag}
        </button>
      )}
    </div>
  );
};

export default Item;
